import React, { useState } from 'react';

//
const ImageTool = () => {
	const [test, setTest] = useState(null);
	//
	return <div>ImageTool</div>;
};

export default ImageTool;
